export default class Locale_MoveAllAllocationsDto {
	SourceResource: string = "Source Resource";
	SourceResourceRequired: string = "Source resource is a required field.";
	TargetResource: string = "Target Resource";
	TargetResourceRequired: string = "Target resource is a required field.";
}